import React from "react";

function TopCard({ title, count }) {
  return (
    <div className="bg-white flex flex-col p-[1.5rem]  rounded-lg w-full">
      <div className="text-[#98A2B3] text-[14px] font-bold">{title}</div>
      <div className="font-bold text-[24px] mt-2">{count}</div>
    </div>
  );
}

export default TopCard;
